import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faArrowLeft, faArrowRight, faComment, faTicket } from '@fortawesome/free-solid-svg-icons';
import { IEnquiryFlight } from '@simplyfly/shared';
import { IEnquiry } from '@simplyfly/shared';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-enquiry-flight-edit-comment',
    templateUrl: './enquiry-flight-edit-comment.component.html',
    styleUrls: ['./enquiry-flight-edit-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, FaIconComponent, TranslateModule]
})
export class EnquiryFlightEditCommentComponent implements OnInit, OnChanges {
  @Input() enquiry: IEnquiry | null = null;
  @Input() enquiryFlight: IEnquiryFlight | null = null;
  @Output() goPrev: EventEmitter<void> = new EventEmitter();
  @Output() saveAndGoNext: EventEmitter<IEnquiryFlight> = new EventEmitter();

  form: FormGroup = this.resetForm();

  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faComment = faComment;

  ngOnInit(): void {
    this.applyEnquiryFlight();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.enquiryFlight &&
      (!changes.enquiryFlight.previousValue ||
        changes.enquiryFlight.previousValue !== changes.enquiryFlight.currentValue)
    ) {
      this.applyEnquiryFlight();
    }
  }

  get comment(): FormControl {
    return this.form.get('comment') as FormControl;
  }

  applyEnquiryFlight(): void {
    this.form = this.resetForm();

    if (this.enquiryFlight) {
      for (const field in this.form.value) {
        if (typeof this.enquiryFlight[field] !== 'undefined') {
          switch (field) {
            default:
              this.form.get(field).setValue(this.enquiryFlight[field]);
              break;
          }
        }
      }

      this.form.enable();
    }
  }

  resetForm(): FormGroup {
    return new FormGroup({
      comment: new FormControl(null)
    });
  }

  prev(): void {
    this.goPrev.emit();
  }

  saveAndNext(): void {
    if (this.form.valid) {
      this.saveAndGoNext.emit(this.form.value);
    }
  }
}
